import React from "react";
import { Trans } from "react-i18next";
import Link from "../Link";

const ReferFriend = ({ t, img }) => {
  return (
    <div id="earn-referral-refer-friend">
      <div className="container grid-container">
        <div className="grid-col-12 grid-col-lg-6 grid-col-xl-5">
          <h2>{t("earnReferral.howToRefer.title")}</h2>
          <ol className="vertical-timeline">
            <li className="vertical-timeline__list">
              <p className="h5">{t("earnReferral.howToRefer.steps.0.title")}</p>
              <p>
                <Trans
                  i18nKey={"earnReferral.howToRefer.steps.0.description"}
                  components={[
                    <Link to="https://zipmex.onelink.me/8NSq/15940e3a" />,
                    <Link
                      to={`${t("common.exchangeLink")}/accounts/sign-in`}
                    />,
                  ]}
                  defaults=" "
                />
              </p>
            </li>
            <li className="vertical-timeline__list">
              <p className="h5">{t("earnReferral.howToRefer.steps.1.title")}</p>
              <p>{t(["earnReferral.howToRefer.steps.1.description", ""])}</p>
            </li>
            <li className="vertical-timeline__list">
              <p className="h5">{t("earnReferral.howToRefer.steps.2.title")}</p>
              <p>{t(["earnReferral.howToRefer.steps.2.description", ""])}</p>
            </li>
          </ol>
        </div>
        <div className="grid-col-12 grid-col-lg-6 grid-col-xl-7 text-center text-lg-right align-self-center">
          <img
            className="img-fluid"
            src={img.publicURL}
            alt="How to Refer a Friend"
            width={443}
          />
        </div>
      </div>
    </div>
  );
};

export default ReferFriend;
